import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';



export default class InputDataView extends Component {
  constructor(props){
    super(props);
    this.state = {
      checked: null,
      selectedOption: "",
    }
  }

  
  // getInputData() {
  // //TO-DO: gets a form for the user to input information
  //   return data;
  // }

  handleChange = (event) => {
    this.setState ({
      selectedOption: event.target.name
    })
    let route = "/upload/" + event.target.name;
    this.props.history.push(route);
  }

  render(){

    return (
      <body id="main-content" className="container">

        <NavLink to="/home" className="previous round back-button" aria-label="Back to dashboard">&#8249;</NavLink>
        <h1 className="upload-center">Which type of bill would you like to enter? {/*<FontAwesomeIcon data-tip data-for="learn" icon={faInfoCircle}/><ReactTooltip id="learn" place="bottom" effect="solid">idk what this is supposed to say</ReactTooltip>*/}</h1>
        
        <div className="container">
          <form className="input-container">
            <input onChange={this.handleChange} type="radio" id="water" name="water" value="Water"></input>
            <label className="input-label" htmlFor="water">Water</label><br></br>

            <input onChange={this.handleChange} type="radio" id="electricity" name="electricity" value="Electricity"></input>
            <label className="input-label" htmlFor="electricity">Electricity</label><br></br>

            <input onChange={this.handleChange} type="radio" id="gas" name="gas" value="Gas"></input>
            <label className="input-label" htmlFor="gas">Gas</label><br></br>
          </form>
          {/* <NavLink aria-label="button" className="input-button" to="#">Continue</NavLink> */}
        </div>
        
      </body>
    )
  }
}